// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__2Eh95","name":"style_name__vI43+","question":"style_question__uvSXR","button":"style_button__FNOJ6"};